var antPrefixCls = '.ant-cascader';
var cascaderStyleFn = function cascaderStyleFn(token) {
  var _activeNotDisab, _antCascaderMenuI, _ref, _ref2;
  return _ref2 = {}, _ref2[antPrefixCls + "-dropdown"] = (_ref = {
    // '.ant-cascader-menu':{
    //   '&::-webkit-scrollbar': {
    //     width: 0,
    //     height: 0,
    //   },
    //   '&::-webkit-scrollbar-track': {
    //     backgroundColor: 'transparent',
    //   },
    //   '&::-webkit-scrollbar-thumb': {
    //     backgroundColor: 'transparent',
    //   },
    // },
    //选择样式
    '.ant-cascader-checkbox-indeterminate .ant-cascader-checkbox-inner': {
      backgroundColor: token.colorPrimary + '!important',
      border: 'none !important',
      '&:after': {
        height: 2,
        backgroundColor: token.colorWhite
      }
    }
  }, _ref[antPrefixCls + "-menu-item"] = {
    borderRadius: 0,
    '&-active:not(&-disabled)': (_activeNotDisab = {}, _activeNotDisab[antPrefixCls + "-menu-item-expand-icon"] = {
      color: token.colorPrimary
    }, _activeNotDisab)
  }, _ref['.ant-cascader-menu-item.ant-cascader-menu-item-disabled'] = (_antCascaderMenuI = {}, _antCascaderMenuI[".ant-cascader-menu-item-expand-icon"] = {
    color: token.colorFill
  }, _antCascaderMenuI), _ref), _ref2;
};

export { cascaderStyleFn };
